import { Divider } from '@outdoorsyco/bonfire';
import React from 'react';
import { useSelector } from 'react-redux';

import { TRootState } from '@/redux/rootReducer';
import { getListingHeader } from '@/redux/selectors/listing/listingHeader';
import { getListingId } from '@/redux/selectors/listing/page';
import { OptimizelyFlags, useExperimentIsEnabled } from '@/services/experiments';

import ListingHeader, { IProps as IListingHeaderProps } from './ListingHeader';

interface IProps {
  onLinkClick: IListingHeaderProps['onLinkClick'];
  divider?: boolean;
  shouldShowProBadge?: boolean;
}

const ListingHeaderContainer: React.FC<IProps> = ({
  onLinkClick,
  divider = true,
  shouldShowProBadge,
}) => {
  const isRenterAge21Enabled = useExperimentIsEnabled(OptimizelyFlags.RENTER_AGE_21);
  const data = useSelector(getListingHeader);
  const isLoading = useSelector<TRootState, boolean>(state => Boolean(state.listing.isLoading));
  const rentalId = useSelector(getListingId);

  const superhostBadgeEnabled = useExperimentIsEnabled(OptimizelyFlags.SUPERHOST_BADGE);

  // Filter out minimum age info when experiment is disabled
  const filteredData = data
    ? {
        ...data,
        infos: data.infos?.filter(info => {
          // Check if this is a minimum age tag (contains "+" and matches age pattern)
          const isMinimumAgeTag = /^\d+\+$/.test(info.label);
          return !isMinimumAgeTag || isRenterAge21Enabled;
        }),
      }
    : data;

  return (
    <>
      <ListingHeader
        loading={isLoading}
        onLinkClick={onLinkClick}
        showProBadge={shouldShowProBadge}
        showSuperhostBadge={superhostBadgeEnabled}
        rentalId={rentalId}
        {...filteredData}
      />
      {divider && <Divider className="mt-2 md:mt-6" />}
    </>
  );
};

export default ListingHeaderContainer;
